<template>
  <f7-page :page-content="false">
    <f7-navbar :title="$t('crontask.tareasprogramadas')" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <!-- La columna de controles lleva tres (ver, editar, ejecutar) y con 70px no caben: `.cell`
           gasta 12px de padding por lado y recorta lo que sobra, así que el de ejecutar quedaba
           pegado al lápiz y el de ver a medias. -->
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="CronTask"
        :tableCode="'CRON_TASK'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="false"
        :controlsWidth="110"
      >
        <template v-slot:tableLinks>
          <a class="link" href="/tareasprogramadas/new/">{{$t('common.nueva')}}</a>
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link icon-f7="eye" color="green" :href="`/tareasprogramadas/view/${item.id}/`" v-tooltip="$t('common.ver')"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/tareasprogramadas/edit/${item.id}/`" v-tooltip="$t('common.editar')"></f7-link>
          <f7-link icon-f7="play_fill" color="green" @click="executeTask(item.id)" v-tooltip="$t('crontask.ejecutar')"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import CronTask from "./../../js/db/CronTask.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      CronTask
    };
  },
  methods: {
    executeTask(id) {
      const self = this;
      self.$f7.dialog.confirm(
        self.$t("crontask.confirmarEjecucion"),
        self.$t("crontask.ejecutar"),
        function() {
          CronTask.execute({ itemId: id }).then(function(res) {
            const resultado = CronTask.resultadoEjecucion(res);
            self.$f7.toast.create({
              icon: resultado.ok
                ? '<i class="f7-icons">checkmark</i>'
                : '<i class="f7-icons">xmark_octagon</i>',
              text: self.$t(resultado.clave),
              position: "center",
              destroyOnClose: true,
              closeTimeout: resultado.ok ? 2000 : 5000
            }).open();
            self.$refs.rlist.reload();
          }).catch(function(error) {
            self.$f7.dialog.alert(error && (error.message || error.error) ? (error.message || error.error) : error);
          });
        }
      );
    }
  }
};
</script>
